import { RECEIVE_ACCOUNTS } from "../actions/accounts";
import moment from "moment";

/* 
  This is a temp hack because accounts in dev database have null dates 
  and we need to test sorting them by date
  */
const getADate = account => {
  if (account && account.timeCreated) {
    return moment(account.timeCreated);
  }
  const daysAgo = Math.floor(Math.random() * 365) + 1;
  return moment().add(-daysAgo, "day");
};

function accounts(state = {}, action) {
  switch (action.type) {
    case RECEIVE_ACCOUNTS:
      const newAccounts = {};

      action.accounts.forEach(a => {
        const account = Object.assign({}, a, { timeCreated: getADate(a) });
        newAccounts[a.id] = account;
      });
      return Object.assign({}, state, newAccounts);
    default:
      return state;
  }
}

export default accounts;



// WEBPACK FOOTER //
// ./src/reducers/accounts.js